import { Device } from '@src/types/Device';
import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';

type CurrentTrackerDeviceContextType = {
  currentTrackerDevice: Device | undefined;
  setCurrentTrackerDevice: React.Dispatch<
    React.SetStateAction<Device | undefined>
  >;
};

const CurrentTrackerDeviceContext = createContext<
  CurrentTrackerDeviceContextType | undefined
>(undefined);

export function CurrentTrackerDeviceProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [currentTrackerDevice, setCurrentTrackerDevice] = useState<Device>();

  const value = useMemo(
    () => ({ currentTrackerDevice, setCurrentTrackerDevice }),
    [currentTrackerDevice],
  );

  return (
    <CurrentTrackerDeviceContext.Provider value={value}>
      {children}
    </CurrentTrackerDeviceContext.Provider>
  );
}

export const useCurrentTrackerDeviceContext =
  (): CurrentTrackerDeviceContextType => {
    const context = useContext(CurrentTrackerDeviceContext);

    if (context === undefined) {
      throw new Error(
        'useCurrentTrackerDeviceContext must be used within CurrentTrackerDeviceProvider',
      );
    }

    return context;
  };
